module.exports = __webpack_public_path__ + "static/img/tu5@1x.3da9ee2.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tu5@1x.png
// module id = uI2/
// module chunks = 2